var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 10,
    fill: "url(#paint0_linear_657_96227)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.17957 18.523C7.17901 20.5395 7.71001 22.5084 8.7197 24.2439L7.08301 30.1734L13.1985 28.5823C14.89 29.496 16.7851 29.9747 18.711 29.9749H18.7161C25.0737 29.9749 30.249 24.8416 30.2517 18.5321C30.2529 15.4747 29.0541 12.5997 26.8759 10.4367C24.6981 8.27393 21.8017 7.08221 18.7156 7.08081C12.3572 7.08081 7.18229 12.2138 7.17966 18.523",
    fill: "url(#paint1_linear_657_96227)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.7673 18.5194C6.76665 20.6084 7.31668 22.6478 8.36237 24.4454L6.66699 30.5874L13.0018 28.9393C14.7472 29.8836 16.7124 30.3814 18.7121 30.3822H18.7172C25.303 30.3822 30.6642 25.0642 30.667 18.5289C30.6681 15.3616 29.4261 12.3833 27.1701 10.1428C24.9138 7.90266 21.9138 6.66805 18.7172 6.66675C12.1304 6.66675 6.76993 11.984 6.7673 18.5194ZM10.5399 24.1358L10.3034 23.7632C9.30905 22.1945 8.78424 20.3816 8.78499 18.5201C8.78705 13.0881 13.2424 8.66861 18.721 8.66861C21.3741 8.66972 23.8675 9.69596 25.7429 11.5579C27.6181 13.4201 28.6501 15.8954 28.6494 18.5281C28.647 23.9602 24.1915 28.3802 18.7172 28.3802H18.7133C16.9308 28.3793 15.1827 27.9043 13.6581 27.0068L13.2953 26.7933L9.53612 27.7712L10.5399 24.1358Z",
    fill: "url(#paint2_linear_657_96227)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7308 13.5642C15.5071 13.0709 15.2717 13.061 15.059 13.0523C14.8848 13.0449 14.6857 13.0454 14.4868 13.0454C14.2876 13.0454 13.9641 13.1197 13.6906 13.416C13.4169 13.7126 12.6455 14.4292 12.6455 15.8868C12.6455 17.3444 13.7155 18.7531 13.8646 18.951C14.014 19.1485 15.9302 22.2354 18.9651 23.4229C21.4874 24.4098 22.0006 24.2135 22.548 24.164C23.0955 24.1147 24.3147 23.4476 24.5634 22.7557C24.8123 22.064 24.8123 21.4711 24.7377 21.3472C24.663 21.2237 24.4639 21.1496 24.1653 21.0015C23.8667 20.8534 22.3987 20.1366 22.125 20.0377C21.8513 19.9389 21.6523 19.8896 21.4531 20.1863C21.254 20.4824 20.6822 21.1496 20.5079 21.3472C20.3339 21.5452 20.1596 21.5699 19.8611 21.4217C19.5623 21.273 18.6007 20.9606 17.4599 19.9514C16.5722 19.1661 15.973 18.1963 15.7988 17.8997C15.6246 17.6035 15.7801 17.4429 15.9299 17.2953C16.064 17.1625 16.2285 16.9493 16.378 16.7764C16.5269 16.6034 16.5765 16.4799 16.6761 16.2824C16.7758 16.0846 16.7259 15.9116 16.6514 15.7634C16.5765 15.6152 15.9963 14.15 15.7308 13.5642Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_657_96227",
    x1: 18,
    y1: 0,
    x2: 18,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_657_96227",
    x1: 1165.52,
    y1: 2316.34,
    x2: 1165.52,
    y2: 7.08081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_657_96227",
    x1: 1206.67,
    y1: 2398.73,
    x2: 1206.67,
    y2: 6.66675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.355448c6b0a1945fad811d4f5d87bded.svg";
export { ForwardRef as ReactComponent };